<template lang="pug">
  .container-reg-2(v-loading="loading", :element-loading-fullscreen="false")
    el-steps(align-center).reg-steps
      el-step(title="填写账号密码", status="success")
      el-step(title="完善商家资料", status="finish")
      el-step(title="绑定联系方式")
    c-header-small
      template(slot="left")
        h3 完善商家资料
    .data-block
      data-row(label="商家类型")
        el-radio(v-model="source.type", :label="1") 公司
        el-radio(v-model="source.type", :label="2") 个人     
    template(v-if="source.type === 1")
      .data-block
        data-row(label="公司名称", required)
          el-input(v-model="source.mch_name")
        data-row(label="营业执照类型")
          el-select(v-model="source.opt")
            el-option(:value="1", label="三证合一，一证一码")
            el-option(:value="2", label="一证三号或三证独立")
        template(v-if="source.opt == 1") 
          data-row(label="统一社会信用代码或注册号", required)
            el-input(v-model="source.uni_credit")
        template(v-else)
          data-row(label="营业执照号", required)
            el-input(v-model="source.business_license")
          data-row(label="组织机构代码", required)
            el-input(v-model="source.organization_code")
          data-row(label="税务登记证件号", required)
            el-input(v-model="source.tax_registration_no")
      .data-block
        data-row(label="法人姓名", required)
          el-input(v-model="source.legal_per_name")
        data-row(label="法人证件类型")
          el-select(v-model="source.legal_per_id_type")
            el-option(value="01", label="身份证")
        data-row(label="法人证件号码", required)
          el-input(v-model="source.legal_per_id_no")
        data-row(label="法人手机号")
          el-input(v-model="source.legal_per_telephone_no")
      .data-block
        data-row(label="责任人姓名", required)
          el-input(v-model="source.resp_per_name")
        data-row(label="法人证件类型")
          el-select(v-model="source.resp_per_id_type")
            el-option(value="01", label="身份证")
        data-row(label="责任人证件号码", required)
          el-input(v-model="source.resp_per_id_no")
      .data-block
        data-row(label="商户电话", required)
          el-input(v-model="source.tel")
        data-row(label="公司地址")
          el-input(v-model="source.business_address")
        data-row(label="结算方式")
          el-select(v-model="source.settle_type")
            el-option(:value="1", :label="1 | settle_type_long")
            //- el-option(:value="3", :label="3 | settle_type_long")
      .data-block
        data-row(label="开户名")
          el-input(v-model="source.public_account_name")
        data-row(label="对公账户账号")
          el-input(v-model="source.public_account")
        data-row(label="开户银行")
          el-select(v-model="source.bankClass", @change="getBankAreaList()", clearable, filterable,value-key="class_code")
            el-option(v-for="b in bankClassList", :key="b.class_code", :value="b", :label="b.class_name")
        data-row(label="开户银行所在地")
          el-select(v-model="source.bankArea", @change="getBankList()", clearable, filterable,value-key="area_code")
            el-option(v-for="b in bankAreaList", :key="b.area_code", :value="b", :label="b.province_name + b.city_name")    
        data-row(label="支行名称")
          el-select(v-model="source.bank", clearable, filterable, value-key="bank_code", @change="getBank()" )
                el-option(v-for="b in bankList", :key="b.bank_code", :value="b", :label="b.bank_name")
      .data-block
        data-row(label="营业执照", required)
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").img-thumbnail
          img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
            @click="$zoom(source.business_license_pic_preview)").img-thumbnail
          template(v-else) 未上传
        data-row(label="法人身份证正面", required)
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'legal_per_id_positive_preview', 'legal_per_id_positive')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.legal_per_id_positive", :src="source.legal_per_id_positive | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").img-thumbnail
          img(v-else-if="source.legal_per_id_positive_preview", :src="source.legal_per_id_positive_preview",
            @click="$zoom(source.legal_per_id_positive_preview)").img-thumbnail
          template(v-else) 未上传
        data-row(label="法人身份证反面", required)
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'legal_per_id_opposite_preview', 'legal_per_id_opposite')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.legal_per_id_opposite", :src="source.legal_per_id_opposite | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").img-thumbnail
          img(v-else-if="source.legal_per_id_opposite_preview", :src="source.legal_per_id_opposite_preview",
            @click="$zoom(source.legal_per_id_opposite_preview)").img-thumbnail
          template(v-else) 未上传
        data-row(label="责任人身份证正面", required)
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_positive_preview', 'resp_per_id_positive')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.resp_per_id_positive", :src="source.resp_per_id_positive | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").img-thumbnail
          img(v-else-if="source.resp_per_id_positive_preview", :src="source.resp_per_id_positive_preview",
            @click="$zoom(source.resp_per_id_positive_preview)").img-thumbnail
          template(v-else) 未上传
        data-row(label="责任人身份证反面", required)
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_opposite_preview', 'resp_per_id_opposite')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.resp_per_id_opposite", :src="source.resp_per_id_opposite | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").img-thumbnail
          img(v-else-if="source.resp_per_id_opposite_preview", :src="source.resp_per_id_opposite_preview",
            @click="$zoom(source.resp_per_id_opposite_preview)").img-thumbnail
          template(v-else) 未上传
        data-row(label="对公账户证明", required)
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'public_account_pic_preview', 'public_account_pic')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.public_account_pic", :src="source.public_account_pic | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").img-thumbnail
          img(v-else-if="source.public_account_pic_preview", :src="source.public_account_pic_preview",
            @click="$zoom(source.public_account_pic_preview)").img-thumbnail
          template(v-else) 未上传

    template(v-if="source.type === 2")
      .data-block
        data-row(label="个人姓名", required)
          el-input(v-model="source.resp_per_name")
        data-row(label="联系地址")
          el-input(v-model="source.business_address")
        data-row(label="结算方式")
          el-select(v-model="source.settle_type")
            el-option(:value="1", :label="1 | settle_type_long")
            //- el-option(:value="3", :label="3 | settle_type_long")
      .data-block
        data-row(label="证件类型")
          el-select(v-model="source.resp_per_id_type")
            el-option(value="01", label="身份证")
        data-row(label="证件号码", required)
          el-input(v-model="source.resp_per_id_no")
      .data-block
        data-row(label="营业执照", required)
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
            @click="$zoom($options.filters.image(source.business_license_pic))").img-thumbnail
          img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
            @click="$zoom(source.business_license_pic_preview)").img-thumbnail
          template(v-else) 未上传
      .data-block
        data-row(label="证件正面")
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_positive_preview', 'resp_per_id_positive')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.resp_per_id_positive", :src="source.resp_per_id_positive | image",
            @click="$zoom($options.filters.image(source.resp_per_id_positive))").img-thumbnail
          img(v-else-if="source.resp_per_id_positive_preview", :src="source.resp_per_id_positive_preview",
            @click="$zoom(source.resp_per_id_positive_preview)").img-thumbnail
          template(v-else) 未上传
      .data-block
        data-row(label="证件反面")
          el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/png,image/jpeg",
            :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_opposite_preview', 'resp_per_id_opposite')")
            el-button(type="primary") 选择文件
        data-row(value-only)
          img(v-if="source.resp_per_id_opposite", :src="source.resp_per_id_opposite | image", 
            @click="$zoom($options.filters.image(source.resp_per_id_opposite))").img-thumbnail
          img(v-else-if="source.resp_per_id_opposite_preview", :src="source.resp_per_id_opposite_preview",
            @click="$zoom(source.resp_per_id_opposite_preview)").img-thumbnail
          template(v-else) 未上传
    .align-center 请根据签约的业务及合同要求，完善商家资料信息，否则将审核不通过。
    el-button(type="primary", @click="save", :disabled="loading").reg-button 下一步
</template>

<script>
export default {
  data() {
    return {
      source: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        tel: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null
      },
      loading: false,
      uploadURL: "/mch_web/v1/upload_picture",
      bankClassList: [],
      bankAreaList: [],
      bankList: []
    };
  },
  methods: {
    next() {
      this.$router.replace("/reg-mobile/3");
    },

    uploadChange(file, previewKey, urlKey) {
      const { size, name } = file;
      if (size < 1 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = e => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.source, previewKey, result);
          const pic_data = result.split(",")[1];

          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.source, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`商家资料图片上传失败。${code}：${msg}`, {
                type: "error"
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过1MB。", {
          type: "error"
        });
      }
    },

    validate() {
      const type = this.source.type;
      if (type === 1) {
        if (!this.source.mch_name) {
          this.$message({
            type: "warning",
            message: `请输入公司名称`
          });
          return false;
        } else if (!this.source.business_license) {
          this.$message({
            type: "warning",
            message: `请输入统一社会信用代码或注册号`
          });
          return false;
        } else if (!this.source.tel) {
          this.$message({
            type: "warning",
            message: `请输入商户电话`
          });
          return false;
        } else if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: `请输入责任人姓名`
          });
          return false;
        } else if (!this.source.legal_per_name) {
          this.$message({
            type: "warning",
            message: "请输入法人姓名"
          });
          return false;
        } else if (!this.source.business_license_pic) {
          this.$message({
            type: "warning",
            message: `请上传营业执照`
          });
          return false;
        }
      } else if (type === 2) {
        if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: "请输入个人姓名"
          });
          return false;
        }
      }

      if (!this.source.resp_per_id_no) {
        const message = type === 1 ? "请输入责任人证件号" : "请输入证件号码";
        this.$message({
          type: "warning",
          message
        });
        return false;
      } else if (
        !this.source.resp_per_id_no.match(this.$regex.idRegex) &&
        this.source.resp_per_id_type === "01"
      ) {
        this.$message({
          type: "warning",
          message: `请输入有效的身份证号码`
        });
        return false;
      }
      return true;
    },

    save() {
      if (this.validate()) {
        this.loading = true;
        const action =
          this.source.type === 1 ? "FILL_COMPANY_DETAIL" : "FILL_PERSON_DETAIL";
        const params = Object.assign({}, this.source, {
          mch_name:
            this.source.type === 1
              ? this.source.mch_name
              : `${this.source.resp_per_name}-${+new Date()}`
        });
        this.$store
          .dispatch(action, params)
          .then(() => {
            this.next();
          })
          .catch(({ code, msg }) => {
            this.$message({
              type: "error",
              message: `商家资料填写失败。${code}：${msg}`
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    // 获取开户银行
    getBankClassList() {
      this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then(data => {
          this.bankClassList = data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`
          });
        });
    },

    // 获取开户银行区域
    getBankAreaList() {
      if (this.source.bankClass) {
        this.source.deposit_bank = this.source.bankClass.class_name;
        this.source.deposit_bank_id = this.source.bankClass.class_code;
        this.$store
          .dispatch("GET_BANK_AREA_LIST", this.source.bankClass.class_code)
          .then(data => {
            this.bankAreaList = data;
            this.source.bankArea = {};
            this.source.bank = {};
          })
          .catch(({ code, msg }) => {
            this.$message({
              type: "error",
              message: `获取银行地区列表失败。${code}：${msg}`
            });
          });
      } else {
        this.source.bankArea = {};
        this.source.bank = {};
        this.source.area_id = null;
        this.source.deposit_bank_id = null;
        this.source.deposit_bank = null;
        this.source.deposit_bank_city = null;
        this.source.sub_branch_bank = null;
        this.source.union_bank = null;
      }
    },

    // 获取支行
    getBankList() {
      if (this.source.bankClass && this.source.bankArea) {
        this.source.bankArea = this.source.bankArea;
        this.source.deposit_bank_province = this.source.bankArea.province_name;
        this.source.deposit_bank_city = this.source.bankArea.city_name;
        this.source.area_id = this.source.bankArea.area_code;
        const params = {
          class_code: this.source.bankClass.class_code,
          area_code: this.source.bankArea.area_code
        };
        this.$store
          .dispatch("GET_BANK_LIST", params)
          .then(data => {
            this.bankList = data;
            this.source.bank = {};
          })
          .catch(({ code, msg }) => {
            this.$message({
              type: "error",
              message: `获取支行列表失败。${code}：${msg}`
            });
          });
      } else {
        this.source.bank = {};
        this.source.deposit_bank = null;
        this.source.deposit_bank_city = null;
        this.source.sub_branch_bank = null;
        this.source.union_bank = null;
      }
    },

    // 获取最后的支行
    getBank() {
      if (this.source.bank) {
        this.source.sub_branch_bank = this.source.bank.bank_name;
        this.source.union_bank = this.source.bank.bank_code;
      } else {
        this.source.sub_branch_bank = null;
        this.source.union_bank = null;
      }
    }
  },
  mounted() {
    this.getBankClassList();
  }
};
</script>

<style lang="less">
.container-reg-2 {
  .reg-hint {
    @media screen and (max-width: 500px) {
      line-height: 20px;
    }
  }
}
</style>
